<template>
  <div class="complex-cleaning-container">
    <div class="service-list">
      <h2 class="section-title">Перечень работ</h2>
      <ul class="service-list-items">
        <li v-for="(task, index) in visibleTasks" :key="index" :class="{ 'category-title': isCategory(task) }">
          <span class="check-icon" v-if="!isCategory(task)">✔️</span>
          <span :class="{ 'highlighted-text': isCategory(task) }">{{ task }}</span>
        </li>
      </ul>
      <div class="button-group">
        <button v-if="!showAll" @click="showAllTasks" class="show-more-btn">Посмотреть все услуги...</button>
        <button v-if="showAll" @click="hideTasks" class="show-more-btn">Скрыть</button>
      </div>
    </div>

    <div class="calculation-area">
      <div class="input-container">
        <div class="calculation-area-container__title">
          <p class="section-title purple-color">{{selectedTab}}</p>
          <div class="wrap-cost">
            <p class="wrap-cost__text">Ставка: {{ currentRate }} руб./кв.м</p></div>
        </div>
        <div class="slider-wrapper">
          <div
              class="slider-tooltip"
              ref="tooltip"
              :style="{ left: tooltipLeft + 'px' }"
          >
            {{ squareMeters }} кв.м
          </div>

          <input
              ref="slider"
              type="range"
              class="slider"
              min="40"
              max="200"
              :value="squareMeters"
              @input="updateSlider"
          />

          <div class="slider-range">
            <span class="range-label">40 кв.м</span>
            <span class="range-label">200 кв.м</span>
          </div>
        </div>
      </div>
      <div class="wrap-total-cost" v-if="isMobile">
        <template v-if="isFirstOrderDiscount">
          <p class="total-cost discount">
            ИТОГО: {{ totalWithoutDiscount }} руб.
          </p>
          <p class="total-cost discount-color" >
            СО СКИДКОЙ: {{ calculateTotalCost() }} руб.
          </p>
        </template>
        <template v-else>
          <p class="total-cost">ИТОГО: {{ calculateTotalCost() }} руб.</p>
        </template>
      </div>
      <div class="extra-services-container">
        <h2 class="section-title-mini">Дополнительные услуги</h2>
        <div class="services-grid">
          <div v-for="(service, index) in services" :key="index" class="service-item">
            <label class="checkbox-container">
              <input type="checkbox" v-model="selectedServices" :value="service" />
              <span class="custom-checkbox"></span>
              <span class="service-text">{{ service.name }} – {{ service.price }} руб.</span>
            </label>
          </div>
          <div class="service-item">
            <label class="checkbox-container">
              <input type="checkbox" v-model="isHeavySoiling" />
              <span class="custom-checkbox"></span>
              Повышенное загрязнение +50% к стоимости заказа*
            </label>
          </div>
        </div>
        <div class="wrap-total-cost"  v-if="!isMobile">
          <template v-if="isFirstOrderDiscount">
            <p class="total-cost discount" >
              ИТОГО: {{ totalWithoutDiscount }} руб.
            </p>
            <p class="total-cost discount-color">
              СО СКИДКОЙ: {{ calculateTotalCost() }} руб.
            </p>
          </template>
          <template v-else>
            <p class="total-cost">ИТОГО: {{ calculateTotalCost() }} руб.</p>
          </template>
        </div>
        <div class="warning-wrap" v-if="isHeavySoiling">
          <span class="warning-text"> *данный вид уборки встречается редко. Когда генеральная уборка, или какой-либо вид уборки, долгое время не производились. Надбавка производится после оценки помещения по фото.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AppComplexCleaning",
    props: {
      baseRate: {
        type: Number,
        required: true
      },
      tasks: {
        type: Array,
        required: true
      },
      services: {
        type: Array,
        required: true
      },
      squareMeters: {
        type: Number,
        required: true
      },
      selectedTab: {
        type: String,
        required: true
      },
      isMobile: {
        type: Boolean,
        required: false,
      }

    },
    emits: ['update:squareMeters'],
    data() {
      return {
        isHeavySoiling: false, // новый флаг
        showAll: false,
        selectedServices: [],
        isFirstOrderDiscount: false,
        tooltipLeft: 0
      };
    },
    // watch: {
    //   squareMeters(val) {
    //     this.$emit('update-square', val);
    //   }
    // },
    watch: {
      selectedServices: {
        handler(services) {
          this.isFirstOrderDiscount = services.some(s => s.isDiscount);
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
      visibleTasks() {
        return this.showAll ? this.tasks : this.tasks.slice(0, 15);
      },
      totalWithoutDiscount() {
        const baseCost = this.squareMeters * this.currentRate; // ← фиксация!
        const extraCost = this.selectedServices.reduce((sum, service) => sum + service.price, 0);

        let total = baseCost + extraCost;

        if (this.isHeavySoiling) total = Math.round(total * 1.5);

        return total;
      },
      currentRate() {
        const s = this.squareMeters;

        // ----- ГЕНЕРАЛЬНАЯ УБОРКА -----
        if (this.selectedTab === 'Генеральная уборка') {

          // 1) Фиксированная ставка 40–80 м²
          if (s <= 80) return 225;

          // 2) Плавное снижение 80–200 м² до 150 руб
          const maxRate = 225;  // ставка при 40–80 м²
          const minRate = 150;  // минимальная ставка при 200 м²
          const sMin = 80;
          const sMax = 200;

          let rate = maxRate - (maxRate - minRate) * ((s - sMin) / (sMax - sMin));
          return Math.round(rate);
        }

        // ----- КОМПЛЕКСНАЯ УБОРКА -----
        if (this.selectedTab === 'Комплексная уборка') {

          // 1) 40–100 м² — фиксированная ставка
          if (s <= 100) return 75;

          // 2) Плавное снижение 100–200 м² до 53 руб
          const maxRate = 75;   // ставка до 100 м²
          const minRate = 53;   // минимальная ставка при 200 м²
          const sMin = 100;
          const sMax = 200;

          let rate = maxRate - (maxRate - minRate) * ((s - sMin) / (sMax - sMin));
          return Math.round(rate);
        }

        // ----- УБОРКА ПОСЛЕ РЕМОНТА -----
        if (this.selectedTab === 'Уборка после ремонта') {
          return s <= 150 ? 180 : 168;
        }

        return this.baseRate;
      }


    },
    methods: {
      updateSlider(e) {
        this.$emit('update-square-meters', Number(e.target.value));
      },
      updateTooltipPosition() {
        const sliderEl = this.$refs.slider;
        const tooltipEl = this.$refs.tooltip;

        if (!sliderEl || !tooltipEl) return;

        const min = Number(sliderEl.min);
        const max = Number(sliderEl.max);
        const percent = (this.squareMeters - min) / (max - min);

        const sliderWidth = sliderEl.offsetWidth;
        const tooltipWidth = tooltipEl.offsetWidth;

        // вычисляем смещение
        let left = sliderWidth * percent - tooltipWidth / 2;

        // 🔒 ограничим только СЛЕВА, минимум 10px
        this.tooltipLeft = Math.max(left, 10);
      },
      calculateTotalCost() {
        const baseCost = this.squareMeters * this.currentRate; // ← фиксация!
        const extraCost = this.selectedServices.reduce((sum, service) => sum + service.price, 0);

        let total = baseCost + extraCost;

        // +50%
        if (this.isHeavySoiling) {
          total *= 1.5;
        }

        // -10% скидка первого заказа
        if (this.isFirstOrderDiscount) {
          total *= 0.9;
        }

        return Math.round(total);
      },
      // calculateTotalCost() {
      //   const baseCost = this.squareMeters * this.currentRate;
      //   const extraCost = this.selectedServices.reduce((sum, service) => sum + service.price, 0);
      //   let total = baseCost + extraCost;
      //
      //   if (this.isHeavySoiling) {
      //     total = Math.round(total * 1.5); // +50%
      //   }
      //
      //   return total;
      // },
      showAllTasks() {
        this.showAll = true;
        this.$nextTick(() => {
          window.parent.postMessage({ type: 'setHeight', height: document.documentElement.scrollHeight }, '*');
        });
      },
      hideTasks() {
        this.showAll = false;
        this.$nextTick(() => {
          window.parent.postMessage({ type: 'setHeight', height: document.documentElement.scrollHeight }, '*');
        });
      },
      isCategory(task) {
        return task.endsWith(":");
      },
      forceUpdateTooltip() {
        this.$forceUpdate(); // вызовет перерасчёт computed
      },
    },
    mounted() {
      this.updateTooltipPosition();
      window.addEventListener('resize', this.updateTooltipPosition);
    },
    updated() {
      this.updateTooltipPosition();
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.updateTooltipPosition);
    },

  };
</script>

<style scoped>

</style>
